export function ready(fn) {
  if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
    fn()
  } else {
    document.addEventListener('DOMContentLoaded', fn)
  }
}

export function objectType(obj){
  return Object.prototype.toString.call(obj).slice(8, -1)
}

export function removeCookie() {
  document.cookie = `${window.CConsentManager.config.cookieName}=; expires=Thu, 01 Jan 1980 00:00:00 UTC; path=/; domain=${window.CConsentManager.config.rootDomain};`
}


export function dispatchEvent(elem, event) {
  var event

  if (typeof(Event) === 'function') {
    event = new Event(event)
  } else {
    event = document.createEvent('Event')
    event.initEvent(event, true, true)
  }
  
  elem.dispatchEvent(event)
}

export function read (value) {
  return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
}

export function write (value) {
  return encodeURIComponent(value).replace(
    /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
    decodeURIComponent
  )
}
